import { roundToStrike } from "@/lib/options/structure";
import type { Mode, Regime } from "@/types/options";
import { defineStrategy } from "./define";
import { leg } from "./leg";

// ── Custom (user-defined legs) ────────────────────────────────────────────
// Scaffolds `leg_count` legs at center strike as long calls.
// Per-leg type/side overrides applied via t_leg_N / s_leg_N in leg-deltas.
// Strike adjustments via d_leg_N as usual.

export const custom = defineStrategy("custom", "Custom", "custom", {
  defaultParams: () => ({ leg_count: 1 }),
  paramSchema: [],
  scaleParams: (_r: Regime, _m: Mode, cur: Record<string, number>) => ({
    ...cur,
  }),
  toLegs: (spot, params, strikeStep) => {
    const count = Math.max(1, params.leg_count ?? 1);
    const strike = roundToStrike(spot, strikeStep);
    return Array.from({ length: count }, () => leg(strike, "call", "long"));
  },
});
